import { gql } from '@apollo/client';

const TrainingElement = gql`
  fragment TrainingElement on TrainingElement {
    id
    priority
    visible
    allowedTrainingTypes
    en
    translation
    type
    enPlaceholders
    enAlternative
    enWrong
    exercise
    translationWrong
    enAudio {
      path
    }
    enGaps
    enFillers
    enFillersWrong
    enSlices
    enSlicesWrong
    youtubeHash
    interlocutor
    images {
      path
      size
    }
    taskTalk {
      speakerName
      images {
        path
        size
      }
    }
    wordProperty
    translationProperty
    elementAnswers {
      id
      correct
      answer
      isCorrect
      trainingType
    },
  }
`;

export default {
  TrainingElement,
};
